import {ServiceBase} from "../ServiceBase";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {AreaType, CashierSessionType} from "@sparkware/uc-sdk-core";
import {CHANNEL_ELEMENTS, CHANNEL_SOURCE} from "../../../common/const/casinofied-analytics-consts";
import {DialogButtonClickHandleResultEnum, ISimpleTextModalButtonOptions} from "../dialog/dialog.service.interface";
import {IGameRunnerService} from "../game-runner/game-runner.service.interface";
import {
    BonusAbuseMoneyParkingEventData
} from "../firebase/topics/messages/publish-data/bonus-abuse-money-parking.event-data";
import {BonusAbuseBetRejectReasonEnum} from "../firebase/topics/messages/raw-data/bet-rejected.raw-data";

/**
 * Prevents bonus abuse money parking in Poker or Sport
 */
export class BonusAbuseMoneyParkingService extends ServiceBase {
    constructor(services: IServiceFactoryExtended) {
        super(services);
        this.services.firebase.topics.messages.events.bonusAbuseParkingMoney.registerListener(this._bonusAbuseParkingMoneyHandler)
    }

    private _bonusAbuseParkingMoneyHandler = async (data: BonusAbuseMoneyParkingEventData) => {
        this.services.analytics.sendOrbitUserFlowEvent('Bonus_Availability_Popup',
                                                    'Show',
                                                           data.GameTypeID.toString(),
                                                           data.RejectionReasonId.toString());


        const gameRunner = await this.services.gameRunner;


        this.services.dialog.showSimpleTextModal({
            title: this.services.translation.translate('BONUS_ABUSE_PARKING_MONEY_TITLE'),
            text: this.services.translation.translate(this._getDialogContentTextTranslationKey(data), {
                RealMoneyBalance: this.services.currency.formatMoney(data.RealMoneyBalance)
            }),
            hideCloseButton: true,
            showPopupAboveSecondWebViewHybrid: true,
            buttons: [
                this._getModalPrimaryButton(),
                this._getModalSecondaryButton(gameRunner)
            ]
        });


    }

    private _getModalPrimaryButton(): ISimpleTextModalButtonOptions {
        return {
            buttonPreset: "primary",
            text: this.services.translation.translate('LOGGED_IN_CASHIER_BTN'),
            onClick: async () => {
                this.services.analytics.sendOrbitUserFlowEvent( 'Bonus_Availability_Popup', 'CTA_Click' , 'cashier_btn');

                //we don't await for promise because we want the popup to be closed and cashier to be open
                this.services.cashier.openCashier({
                    sessionType: CashierSessionType.FullCashier,
                    channel: {
                        source: CHANNEL_SOURCE.casinoClient,
                        area: AreaType.Message,
                        element: CHANNEL_ELEMENTS.depositButton
                    }

                });

                return DialogButtonClickHandleResultEnum.CloseDialogAndContinue;
            }
        }
    }

    private _getModalSecondaryButton(gameRunner: IGameRunnerService): ISimpleTextModalButtonOptions {
        const isGameRunning = Boolean(gameRunner.currentRunningGame);
        return {
            buttonPreset: "secondary",
            text: isGameRunning ? this.services.translation.translate('CLOSE_GAME') : this.services.translation.translate('CLOSE'),
            onClick: async () => {
                let label = 'Close Message';
                if(isGameRunning) {
                    label = 'Close Game';
                    await gameRunner.closeCurrentGame({
                        shouldSuggestNextGame: false
                    });
                }

                this.services.analytics.sendOrbitUserFlowEvent( 'Bonus_Availability_Popup', 'CTA_Click', label);
                return DialogButtonClickHandleResultEnum.CloseDialogAndContinue;
            }
        }
    }

    private _getDialogContentTextTranslationKey(data: BonusAbuseMoneyParkingEventData): string {
        switch(data.RejectionReasonId){
            case BonusAbuseBetRejectReasonEnum.Poker:
                if(data.RealMoneyBalance > 0) {
                    return 'BONUS_ABUSE_PARKING_MONEY_TEXT_POKER_WITH_REAL_MONEY';
                } else {
                    return 'BONUS_ABUSE_PARKING_MONEY_TEXT_POKER_WITHOUT_REAL_MONEY';
                }
            case BonusAbuseBetRejectReasonEnum.Sport:
                if(data.RealMoneyBalance > 0) {
                    return `BONUS_ABUSE_PARKING_MONEY_TEXT_SPORT_WITH_REAL_MONEY`;
                } else {
                    return `BONUS_ABUSE_PARKING_MONEY_TEXT_SPORT_WITHOUT_REAL_MONEY`;
                }

            case BonusAbuseBetRejectReasonEnum.PokerAndSport:
                if(data.RealMoneyBalance > 0) {
                    return `BONUS_ABUSE_PARKING_MONEY_TEXT_POKER_AND_SPORT_WITH_REAL_MONEY`;
                } else {
                    return `BONUS_ABUSE_PARKING_MONEY_TEXT_POKER_AND_SPORT_WITHOUT_REAL_MONEY`;
                }
            default:
                return null;

        }
    }
}